import MainSearch from '@/components/common/MainSearch/MainSearch';
import useSearchContracts from '../hooks/useSearchContracts';

const PLACEHOLDER = 'Search by Contract Number or Customer Name or Customer Account Number';
interface ISearchContractsContainerProps {
  handleChangeCustomerID: (id: string | null) => void
}

export default function SearchContractsContainer({ handleChangeCustomerID }: ISearchContractsContainerProps) {
  const { getSearchResults, isLoadingSearchContracts, searchResult } = useSearchContracts(handleChangeCustomerID);

  return (
    <MainSearch
      handleChange={getSearchResults}
      data={searchResult}
      loading={isLoadingSearchContracts}
      placeholder={PLACEHOLDER}
    />
  );
}
